//加载region下拉
export function initRegion(regionData, region) {
    let selectedRegionCode = region;
    let list = regionData;
    if (list.length === 0 && !selectedRegionCode) {
        return;
    }
    if (
        list.length > 0 &&
        !selectedRegionCode &&
        !_.find(list, (item) => item.regionCode === getRegion())
    ) {
        selectedRegionCode = list[0].regionCode;
    }
    console.log(selectedRegionCode, 'region');
    return window.__ksStorage__.initRegion(regionData, selectedRegionCode);
}